import { createPortal } from "react-dom";
import React, { useState } from 'react'
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IndustrySendCollaborationRequestModal = ({ isOpen, onClose, industry_id }) => {
  const [project_title, setProjectTitle] = useState("")
  const [project_domain, setProjectDomain] = useState("")
  const [project_description, setProjectDescription] = useState("")
  const [problem_statement, setProblemStatement] = useState("")
  const [collaboration_type, setCollaborationType] = useState("")
  const [expected_support, setExpectedSupport] = useState("")
  const [current_project_state, setCurrentProjectState] = useState("")
  const [project_duration, setProjectDuration] = useState("")
  const [budget, setBudget] = useState("")
  const [stack, setStack] = useState("")
  const [proposal_file, setProposalFile] = useState(null)
  const [demo_link, setDemoLink] = useState("")
  const [additional_notes, setAdditionalNotes] = useState("")
  const [loading, setLoading] = useState(false)
  const HandleSubmitCollaborationRequest = async (e) => {
    e.preventDefault();

    try {
      if (!industry_id) {
        alert("Industry Id is required to send the proposal")
        return;
      }
      if (!project_domain) {
        alert("Project domain is required!");
        return;
      }

      if (!collaboration_type) {
        alert("Collaboration type is required!");
        return;
      }

      if (!current_project_state) {
        alert("Current project stage is required!");
        return;
      }

      if (!proposal_file) {
        alert("Proposal file is required!");
        return;
      }

      const formData = new FormData();
      formData.append("industry", industry_id)
      formData.append("project_title", project_title);
      formData.append("project_domain", project_domain);
      formData.append("project_description", project_description);
      formData.append("problem_statement", problem_statement);
      formData.append("collaboration_type", collaboration_type);
      formData.append("expected_support", expected_support);
      formData.append("current_project_stage", current_project_state);
      formData.append("project_duration", project_duration);
      formData.append("budget_requirement", budget);
      formData.append("technology_stack", stack);
      formData.append("proposal_document", proposal_file);
      formData.append("demo_link", demo_link);
      formData.append("additional_notes", additional_notes);
      setLoading(true)
      const response = await axios.post(
        `${BASE_URL}/marketplace/industry/collaboration/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );

      // console.log("Success:", response.data);

      alert("Collaboration request sent successfully!");
      setProjectTitle("")
      setProjectDomain("")
      setProjectDescription("")
      setProblemStatement("")
      setCollaborationType("")
      setExpectedSupport("")
      setCurrentProjectState("")
      setProjectDuration("")
      setBudget("")
      setStack("")
      setProposalFile(null)
      setDemoLink("")
      setAdditionalNotes("")
      onClose()

    } catch (error) {
       alert(error.response.data.error)
      console.log("error while make collaboration", error)
      setLoading(false)
    } finally {
      setLoading(false)
    }
  };
  if (!isOpen) return null;
  return createPortal(
    <div className="fixed inset-0 z-[100000] bg-black/50 flex items-center justify-center overflow-hidden">
      <div className="bg-white rounded-2xl w-full max-w-4xl shadow-xl max-h-[90vh] overflow-y-auto">

        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900">Send Collaboration Request</h2>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
          // disabled={loading}
          >
            <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        {/* Content */}
        <div className="bg-gray-100 min-h-screen flex items-center justify-center p-6">

          <div className="w-full max-w-3xl bg-white rounded-2xl shadow-xl p-8">

            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h1 className="text-2xl font-bold text-gray-800">
                Project Collaboration Request
              </h1>
            </div>

            <p className="text-gray-500 mb-8">
              Submit your project details for industry collaboration.
            </p>

            <form className="space-y-6" onSubmit={HandleSubmitCollaborationRequest}>

              {/* Project Title */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700">
                    Project Title
                  </label>
                </div>
                <input
                  type="text"
                  value={project_title}
                  onChange={(e) => setProjectTitle(e.target.value)}
                  required
                  placeholder="Enter project title"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                />
              </div>

              {/* Project Domain */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700">
                    Project Domain
                  </label>
                </div>
                <select
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                  value={project_domain}
                  required
                  onChange={(e) => setProjectDomain(e.target.value)}
                >
                  <option>Select Domain</option>
                  <option>Artificial Intelligence</option>
                  <option>Web Development</option>
                  <option>Mobile App</option>
                  <option>Cloud Computing</option>
                  <option>IoT</option>
                  <option>Cybersecurity</option>
                  <option>Data Science</option>
                  <option>Robotics</option>
                </select>
              </div>

              {/* Project Description */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700">
                    Project Description
                  </label>
                </div>
                <textarea
                  rows={5}
                  value={project_description}
                  onChange={(e) => setProjectDescription(e.target.value)}
                  required
                  placeholder="Describe your project..."
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                ></textarea>
              </div>

              {/* Problem Statement */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700">
                    Problem Statement
                  </label>
                </div>
                <textarea
                  rows={4}
                  value={problem_statement}
                  onChange={(e) => setProblemStatement(e.target.value)}
                  placeholder="What problem does your project solve?"
                  required
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                ></textarea>
              </div>

              {/* Collaboration Type */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700">
                    Collaboration Type
                  </label>
                </div>
                <select
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                  value={collaboration_type}
                  required
                  onChange={(e) => setCollaborationType(e.target.value)}
                >
                  <option value="">Select Collaboration Type</option>

                  <option value="RESEARCH">
                    Research Collaboration
                  </option>

                  <option value="TECH">
                    Technical Partnership
                  </option>

                  <option value="FUNDING">
                    Funding Support
                  </option>

                  <option value="INTERNSHIP">
                    Internship Partnership
                  </option>

                  <option value="PRODUCT">
                    Product Development
                  </option>

                  <option value="MENTORSHIP">
                    Industrial Mentorship
                  </option>

                  <option value="DATASET">
                    Dataset Sharing
                  </option>
                </select>
              </div>

              {/* Expected Support */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700">
                    Expected Support from Industry
                  </label>
                </div>
                <textarea
                  rows={4}
                  value={expected_support}
                  onChange={(e) => setExpectedSupport(e.target.value)}
                  required
                  placeholder="Describe expected support..."
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                ></textarea>
              </div>

              {/* Two Columns */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                {/* Current Stage */}
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                    <label className="text-sm font-semibold text-gray-700">
                      Current Project Stage
                    </label>
                  </div>
                  <select
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                    value={current_project_state}
                    onChange={(e) => setCurrentProjectState(e.target.value)}
                    required
                  >
                    <option value="">Select Stage</option>

                    <option value="IDEA">
                      Idea
                    </option>

                    <option value="RESEARCH">
                      Research
                    </option>

                    <option value="PROTOTYPE">
                      Prototype
                    </option>

                    <option value="MVP">
                      MVP
                    </option>

                    <option value="COMPLETED">
                      Completed
                    </option>
                  </select>
                </div>

                {/* Duration */}
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                    <label className="text-sm font-semibold text-gray-700">
                      Project Duration
                    </label>
                  </div>
                  <input
                    type="text"
                    value={project_duration}
                    onChange={(e) => setProjectDuration(e.target.value)}
                    required
                    placeholder="e.g. 6 Months"
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                  />
                </div>

              </div>

              {/* Budget */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700">
                    Budget Requirement
                  </label>
                </div>
                <input
                  type="number"
                  value={budget}
                  onChange={(e) => setBudget(e.target.value)}
                  required
                  placeholder="Enter estimated budget"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                />
              </div>

              {/* Technology Stack */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700">
                    Technology Stack
                  </label>
                </div>
                <input
                  type="text"
                  value={stack}
                  onChange={(e) => setStack(e.target.value)}
                  required
                  placeholder="e.g. React, Django, TensorFlow"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                />
              </div>

              {/* Proposal Upload */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700">
                    Proposal / Document Upload
                  </label>
                </div>
                <input
                  type="file"
                  accept=".pdf"
                  onChange={(e) => setProposalFile(e.target.files[0])}
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 text-gray-700"
                />
              </div>

              {/* Demo Link */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700">
                    Demo Link
                  </label>
                </div>
                <input
                  type="url"
                  value={demo_link}
                  onChange={(e) => setDemoLink(e.target.value)}
                  placeholder="https://example.com"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                />
              </div>

              {/* Additional Notes */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700">
                    Additional Notes
                  </label>
                </div>
                <textarea
                  rows={4}
                  value={additional_notes}
                  onChange={(e) => setAdditionalNotes(e.target.value)}
                  placeholder="Any additional information..."
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0f6abf] focus:border-transparent"
                ></textarea>
              </div>

              {/* Submit Button */}
              <button
  type="submit"
  disabled={loading}
  className="w-full bg-[#0f6abf] hover:bg-[#0a5ca8] disabled:bg-blue-400 text-white font-semibold py-3 rounded-xl transition duration-300 flex items-center justify-center gap-2"
>
  {loading && (
    <svg
      className="w-5 h-5 animate-spin"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
    </svg>
  )}

  {loading
    ? "Sending Collaboration Request..."
    : "Send Collaboration Request"}
</button>

            </form>

          </div>

        </div>
      </div>

    </div>,
    document.body
  )
}

export default IndustrySendCollaborationRequestModal
